module.exports = __webpack_public_path__ + "img/csm__MG_9102_3af2c8a915.5d888638.jpg";